import { cqrs } from '@faro/http-clients';
import { Identified } from '@faro/realtime-services';
import {
    CommandResponse,
    ObjectiveGroup,
    RevisionedCommandResponse,
    toObjectiveGroup,
} from '@faro/study-designer-model';
import axios from 'axios';
import { Identifiable } from 'faro-common-model';
import { RevisionQueryParameter, StudyPathParameter } from '../parameter';

export type ObjectiveGroupPathParameters = StudyPathParameter;
export type ObjectiveGroupQueryParameters = RevisionQueryParameter;

const factory = cqrs<ObjectiveGroup, ObjectiveGroupPathParameters>(
    '/api/study-designer/studies/:studyId/objective-groups',
    toObjectiveGroup
);

export const objectiveGroupClient = {
    ...factory.writableEntityClient<ObjectiveGroupQueryParameters>(),
    delete: async (
        request: ObjectiveGroupPathParameters & Identifiable,
        signal?: AbortSignal
    ): Promise<RevisionedCommandResponse<CommandResponse>> =>
        axios.delete(`/api/study-designer/studies/${request.studyId}/objective-groups/${request.id}`, {
            signal,
        }),
    clone: async (
        request: Partial<ObjectiveGroup> & Identifiable & { sequenceNumber: number; sectionId: string },
        signal?: AbortSignal
    ): Promise<Identified> => {
        const response = await axios.post(
            `/api/study-designer/studies/${request.studyId}/objective-groups/${request.id}/actions/clone`,
            request,
            { signal }
        );

        return response.data;
    },
    move: async (
        request: ObjectiveGroupPathParameters & Identifiable & { sequenceNumber: number; sectionId: string },
        signal?: AbortSignal
    ): Promise<RevisionedCommandResponse<CommandResponse>> => {
        const response = await axios.post(
            `/api/study-designer/studies/${request.studyId}/objective-groups/${request.id}/actions/move`,
            request,
            { signal }
        );

        return response.data;
    },
};
